import { IClearanceRole } from '@/domain/auth/interfaces/accessControl';
import { IPartnerListItem, IWhoamiResponse } from '@/domain/auth/interfaces/user';
import { createStore } from '@/lib/zustand';

type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  user: IWhoamiResponse | null;
  partnersList: Array<IPartnerListItem>;
  userClearanceRoles: Array<IClearanceRole>;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setUser: (user: IWhoamiResponse) => void;
  setPartnersList: (list: Array<IPartnerListItem>) => void;
  setUserClearanceRoles: (roles: Array<IClearanceRole>) => void;
  setInitialized: (value: boolean) => void;
  clearTokens: () => void;
};

export const authStore = createStore<AuthState>(
  (set) => ({
    isAuthenticated: false,
    isInitialized: false,
    accessToken: null,
    refreshToken: null,
    user: null,
    partnersList: [],
    userClearanceRoles: [],
    setTokens: (accessToken, refreshToken) => set({ isAuthenticated: true, accessToken, refreshToken }),
    setUser: (user) => set({ user }),
    setPartnersList: (partnersList) => set({ partnersList }),
    setUserClearanceRoles: (userClearanceRoles) => set({ userClearanceRoles }),
    setInitialized: (value) => set({ isInitialized: value }),
    clearTokens: () =>
      set({
        isAuthenticated: false,
        accessToken: null,
        refreshToken: null,
        user: null,
        partnersList: [],
        userClearanceRoles: [],
      }),
  }),
  // The session outlives an account switch; the switch itself refreshes `user` and the roles.
  { keepOnPartnerSwitch: true },
);
